import React, { useEffect, useState } from "react";
import { getEvents } from "../Service/Api";
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
const HomeEvent = () => {
  const [data, setData] = useState([]);
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  useEffect(() => {
     const getData = async () => {
        const datas = await getEvents();
        setData(datas);
     };
     getData();
  }, []);
    var settings = { 
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,  
        arrows:false,
        adaptiveHeight: true,
        responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 3, 
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2, 
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow:2,  
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1 
              }
            }
          ]
      };
  return (
     <> 
     <div className="row">
     <div className="eventbg">
     <Slider {...settings}> 
     {data.length > 0 && data.map((item, index) => { 
      const date = new Date(item.date);
      const mon = monthNames[date.getMonth()];
      const eventdate = date.getDate();
      const eventyear = date.getFullYear();
        
      return (
        <div className="item" key={index}>
                         <div className="event-blk">
                          <h4 className="evt-date">{eventdate}
                            <span>{mon} 25</span>
                          </h4>
                          <LazyLoad>
                          {item?.images.length > 0 ? (
                              <img src={`https://webapi.entab.info/api/image/${item?.images[0]}`} alt="Gallery" className="img-fluid" />
                          ) : (
                              <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/events.jpg" alt="Gallery Placeholder" className="img-fluid" />
                          )}
                      </LazyLoad>
                              <h3> {item.title}</h3> 
                               <Link to="/Events">Read More <i class="bi bi-chevron-double-right"></i></Link>
                          </div>
                    </div> 
          )})}  
       </Slider>
       {/* <button className="button">
        <Link to="/events">
        Read More</Link>
       </button> */}
     </div>
     </div>
     </>
  )
}

export default HomeEvent